import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import styles from "./RelatedArticles.module.scss";
import { ArticlePreview } from "./ArticlePreview";
import { useRouterContext } from "../../../../context/RouterContext";
export type ArticleHeader = {
  title: string;
  inngress?: string;
  published?: string;
};
export type RelatedArticle = {
  header: ArticleHeader;
  slug: string;
};
export const RelatedArticles: React.FC<{
  relatedArticles: RelatedArticle[];
  relatedArticlesLabel: string;
  seeAllArticlesLabel: string;
}> = t0 => {
  const $ = _c(20);
  const {
    relatedArticles,
    relatedArticlesLabel,
    seeAllArticlesLabel
  } = t0;
  const {
    articlesPagePath
  } = useRouterContext();
  let t1;
  if ($[0] !== relatedArticlesLabel) {
    t1 = <h4>{relatedArticlesLabel}</h4>;
    $[0] = relatedArticlesLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== articlesPagePath) {
    t2 = articlesPagePath.join("/");
    $[2] = articlesPagePath;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `/${t2}`;
  let t4;
  if ($[4] !== seeAllArticlesLabel) {
    t4 = <span>{seeAllArticlesLabel}</span>;
    $[4] = seeAllArticlesLabel;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div>→</div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t4) {
    t6 = <div className={styles.viewall}><Link href={t3}>{t4}{t5}</Link></div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t6) {
    t7 = <div className={styles.header}>{t1}{t6}</div>;
    $[10] = t1;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== relatedArticles) {
    t8 = relatedArticles && <ul className={styles.list}>{relatedArticles.filter(_temp).map(_temp2)}</ul>;
    $[13] = relatedArticles;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <div className={styles.articles}>{t8}</div>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t9) {
    t10 = <div className={styles.wrapper} data-toc-id="related">{t7}{t9}</div>;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
function _temp(article) {
  return article?.slug && article?.header?.title;
}
function _temp2(article_0) {
  return <ArticlePreview key={article_0.slug} header={article_0.header} slug={article_0.slug} />;
}